export function getTokens() {
  return window.axios
    .get(`/hub/v1/account/api-tokens`)
    .then((response) => response.data);
}

export function addToken({ expiredAt }) {
  return window.axios
    .post(`/hub/v1/account/api-tokens`, {
      expiredAt,
    })
    .then((response) => response.data);
}

export function updateToken({ id, expiredAt }) {
  return window.axios
    .put(`/hub/v1/account/api-tokens/${id}/set-expiration`, {
      expiredAt,
    })
    .then((response) => response.data);
}

export function getUserProjectandApis() {
  return window.axios
    .get(`/hub/v1/account/apis`)
    .then((response) => response.data);
}
